import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes';

export const TILE_AD_KEY = 'productTile';
export const BILLBOARD_AD_KEY = 'billboard';
export const SKYSCRAPER_AD_KEY = 'skyscraper';

const AD_JEWELRY = {
    [BILLBOARD_AD_KEY]: {
        desktop: {
            adId: '/5391766/Jewelry_BottomBillboardBanner',
            elementId: 'finding-wide-ad',
            width: 970,
            height: 250,
        },
        tablet: {
            adId: '/5391766/Small_Jewelry_BillboardBanner',
            elementId: 'finding-wide-tablet-ad',
            width: 746,
            height: 192,
        },
        mobile: {
            adId: '/5391766/Jewelry_BillboardBanner_Mobile',
            elementId: 'finding-mobile-ad',
            width: 320,
            height: 82,
        },
    },
    [SKYSCRAPER_AD_KEY]: {
        adId: '/5391766/Jewelry_WideSkyscraper',
        elementId: 'finding-narrow-ad',
        width: 160,
        height: 600,
    },
    [TILE_AD_KEY]: [
        {
            adId: '/5391766/FeaturedItem_Jewelry_ONE',
            elementId: 'finding-1x1-ad-1',
            targetEl: 'finding-1x1-ad-wrap-1',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/FeaturedItem_Jewelry_TWO',
            elementId: 'finding-1x1-ad-2',
            targetEl: 'finding-1x1-ad-wrap-2',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/FeaturedItem_Jewelry_THREE',
            elementId: 'finding-1x1-ad-3',
            targetEl: 'finding-1x1-ad-wrap-3',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/FeaturedItem_Jewelry_FOUR',
            elementId: 'finding-1x1-ad-4',
            targetEl: 'finding-1x1-ad-wrap-4',
            width: 331,
            height: 419,
        },
    ],
};

const AD_FASHION = {
    [TILE_AD_KEY]: [
        {
            adId: '/5391766/FeaturedItem_Fashion_ONE',
            elementId: 'finding-1x1-ad-1',
            targetEl: 'finding-1x1-ad-wrap-1',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/FeaturedItem_Fashion_TWO',
            elementId: 'finding-1x1-ad-2',
            targetEl: 'finding-1x1-ad-wrap-2',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/FeaturedItem_Fashion_THREE',
            elementId: 'finding-1x1-ad-3',
            targetEl: 'finding-1x1-ad-wrap-3',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/FeaturedItem_Fashion_FOUR',
            elementId: 'finding-1x1-ad-4',
            targetEl: 'finding-1x1-ad-wrap-4',
            width: 331,
            height: 419,
        },
    ],
    [BILLBOARD_AD_KEY]: {
        desktop: {
            adId: '/5391766/Fashion_BillboardBanner',
            elementId: 'finding-wide-ad',
            width: 970,
            height: 250,
        },
        tablet: {
            adId: '/5391766/Small_Fashion_BillboardBanner',
            elementId: 'finding-wide-tablet-ad',
            width: 746,
            height: 192,
        },
        mobile: {
            adId: '/5391766/Fashion_BillboardBanner_Mobile',
            elementId: 'finding-mobile-ad',
            width: 320,
            height: 82,
        },
    },
    [SKYSCRAPER_AD_KEY]: {
        adId: '/5391766/Fashion_WideSkyscraper',
        elementId: 'finding-narrow-ad',
        width: 160,
        height: 600,
    },
};

const AD_FURNITURE = {
    [BILLBOARD_AD_KEY]: {
        desktop: {
            adId: '/5391766/Bottom_Billboard_Banner',
            elementId: 'finding-wide-ad',
            width: 970,
            height: 250,
        },
        tablet: {
            adId: '/5391766/Small_Furniture_BillboardBanner',
            elementId: 'finding-wide-tablet-ad',
            width: 746,
            height: 192,
        },
        mobile: {
            adId: '/5391766/Bottom_Billboard_Banner_Mobile',
            elementId: 'finding-mobile-ad',
            width: 320,
            height: 82,
        },
    },
    [SKYSCRAPER_AD_KEY]: {
        adId: '/5391766/Furniture_WideSkyscraper',
        elementId: 'finding-narrow-ad',
        width: 160,
        height: 600,
    },
    [TILE_AD_KEY]: [
        {
            adId: '/5391766/Featured_Item_v2_ONE',
            elementId: 'finding-1x1-ad-1',
            targetEl: 'finding-1x1-ad-wrap-1',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/Featured_Item_v2_TWO',
            elementId: 'finding-1x1-ad-2',
            targetEl: 'finding-1x1-ad-wrap-2',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/Featured_Item_v2_THREE',
            elementId: 'finding-1x1-ad-3',
            targetEl: 'finding-1x1-ad-wrap-3',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/Featured_Item_v2_FOUR',
            elementId: 'finding-1x1-ad-4',
            targetEl: 'finding-1x1-ad-wrap-4',
            width: 331,
            height: 419,
        },
    ],
};

const AD_ART = {
    [BILLBOARD_AD_KEY]: {
        desktop: {
            adId: '/5391766/FineArt_BottomBillboard',
            elementId: 'finding-wide-ad',
            width: 970,
            height: 250,
        },
        tablet: {
            adId: '/5391766/Small_FineArt_BillboardBanner',
            elementId: 'finding-wide-tablet-ad',
            width: 746,
            height: 192,
        },
        mobile: {
            adId: '/5391766/FineArt_BillboardBanner_Mobile',
            elementId: 'finding-mobile-ad',
            width: 320,
            height: 82,
        },
    },
    [SKYSCRAPER_AD_KEY]: {
        adId: '/5391766/FineArt_WideSkyscraper',
        elementId: 'finding-narrow-ad',
        width: 160,
        height: 600,
    },
    [TILE_AD_KEY]: [
        {
            adId: '/5391766/FeaturedItem_FineArt_One',
            elementId: 'finding-1x1-ad-1',
            targetEl: 'finding-1x1-ad-wrap-1',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/FeaturedItem_FineArt_Two',
            elementId: 'finding-1x1-ad-2',
            targetEl: 'finding-1x1-ad-wrap-2',
            width: 331,
            height: 419,
        },
    ],
};

const AD_SALE = {
    [SKYSCRAPER_AD_KEY]: {
        adId: '/5391766/SaturdaySale_Skyscraper',
        elementId: 'finding-narrow-ad',
        width: 240,
        height: 400,
    },
};

const AD_DEFAULT = {
    [BILLBOARD_AD_KEY]: {
        desktop: {
            adId: '/5391766/Bottom_Billboard_Banner',
            elementId: 'finding-wide-ad',
            width: 970,
            height: 250,
        },
    },
};

const AD_CATALOGUE_COLLECTION = {
    [BILLBOARD_AD_KEY]: {
        desktop: {
            adId: '/5391766/Bottom_Billboard_Banner_Catalogue',
            elementId: 'finding-wide-ad',
            width: 970,
            height: 250,
        },
        mobile: {
            adId: '/5391766/Bottom_Billboard_Banner_Catalogue_Mobile',
            elementId: 'finding-mobile-ad',
            width: 320,
            height: 82,
        },
    },
};

export const AD_HOLIDAY_COLLECTION = {
    [TILE_AD_KEY]: [
        {
            adId: '/5391766/Featured_Item_Banner_Holiday_Collection_2020_1',
            elementId: 'holiday-collection-1x1-ad-1',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/Featured_Item_Banner_Holiday_Collection_2020_2',
            elementId: 'holiday-collection-1x1-ad-2',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/Featured_Item_Banner_Holiday_Collection_2020_3',
            elementId: 'holiday-collection-1x1-ad-3',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/Featured_Item_Banner_Holiday_Collection_2020_4',
            elementId: 'holiday-collection-1x1-ad-4',
            width: 331,
            height: 419,
        },
    ],
    [BILLBOARD_AD_KEY]: {
        desktop: {
            adId: '/5391766/Bottom_Billboard_Banner_Holiday_2020',
            elementId: 'finding-wide-ad',
            width: 970,
            height: 250,
        },
        tablet: {
            adId: '/5391766/Bottom_Billboard_Banner_Holiday_2020_Tablet',
            elementId: 'finding-wide-tablet-ad',
            width: 746,
            height: 192,
        },
        mobile: {
            adId: '/5391766/Bottom_Billboard_Banner_Holiday_2020_Mobile',
            elementId: 'finding-mobile-ad',
            width: 320,
            height: 82,
        },
    },
};

const AD_HOLIDAY_SUB_COLLECTION = {
    [BILLBOARD_AD_KEY]: {
        desktop: {
            adId: '/5391766/Bottom_Billboard_Banner_Holiday_2020_SubGiftGuides',
            elementId: 'finding-wide-ad',
            width: 970,
            height: 250,
        },
        mobile: {
            adId: '/5391766/Bottom_Billboard_Banner_Holiday_2020_SubGiftGuides_Mobile',
            elementId: 'finding-mobile-ad',
            width: 320,
            height: 82,
        },
    },
};

const AD_VALENTINES_COLLECTION = {
    [TILE_AD_KEY]: [
        {
            adId: '/5391766/Featured_Item_Banner_Valentine_1',
            elementId: 'holiday-collection-1x1-ad-1',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/Featured_Item_Banner_Valentine_2',
            elementId: 'holiday-collection-1x1-ad-2',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/Featured_Item_Banner_Valentine_3',
            elementId: 'holiday-collection-1x1-ad-3',
            width: 331,
            height: 419,
        },
        {
            adId: '/5391766/Featured_Item_Banner_Valentine_4',
            elementId: 'holiday-collection-1x1-ad-4',
            width: 331,
            height: 419,
        },
    ],
    [BILLBOARD_AD_KEY]: {
        desktop: {
            adId: '/5391766/Bottom_Billboard_Banner_Valentine',
            elementId: 'finding-wide-ad',
            width: 970,
            height: 250,
        },
        mobile: {
            adId: '/5391766/Bottom_Billboard_Banner_Valentine_Mobile',
            elementId: 'finding-mobile-ad',
            width: 320,
            height: 82,
        },
    },
};

export const sbAdMap = {
    jewelry: AD_JEWELRY,
    fashion: AD_FASHION,
    furniture: AD_FURNITURE,
    art: AD_ART,
    sale: AD_SALE,
    contemporary: AD_FURNITURE,
    'design-gestalt': AD_CATALOGUE_COLLECTION,
    'holiday-gift-guide': AD_HOLIDAY_COLLECTION,
    'art-gifts': AD_HOLIDAY_SUB_COLLECTION,
    'jewelry-gifts': AD_HOLIDAY_SUB_COLLECTION,
    'rare-gifts': AD_HOLIDAY_SUB_COLLECTION,
    'iconic-gifts': AD_HOLIDAY_SUB_COLLECTION,
    'valentines-gift-guide': AD_VALENTINES_COLLECTION,
    default: AD_DEFAULT,
};

export const sbAdExcludeMap = {
    [PAGE_TYPE.MORE_FROM_SELLER]: [TILE_AD_KEY],
    [PAGE_TYPE.DEALERS]: [TILE_AD_KEY],
};
